import React from 'react';
import { Table } from 'react-bootstrap';

import { formatNumberBR } from 'components/Relatorios/shared/RelatorioTable';
import SubtitleSemiBold from 'components/Typography/SubtitleSemiBold';
import { MatrizPrecosTabela } from 'types/Relatorios/Matriz';

import './index.scss';

interface Props { tabela: MatrizPrecosTabela; }

/**
 * Tabela "Preços SE (R$/MWvh)" da Matriz: canto de cabeçalho em 2 linhas
 * (ENA/SE em cima, S embaixo ocupando a largura do canto) seguido de 9
 * colunas de percentil (rowSpan 2, alinhadas ao topo do canto) — cabeçalho
 * agrupado que `RelatorioTable` (shared) não suporta (só header plano), mesmo
 * padrão bespoke do Preços do DESSEM
 * (`Dessem/secoes/Resultados/PrecosTable`). `semCard` implícito: as 2
 * tabelas já vivem dentro do Card "Chuva Observada" do componente pai.
 */
export default function PrecosSeTable({ tabela }: Props) {
  return (
    <>
      <SubtitleSemiBold>{tabela.titulo}</SubtitleSemiBold>
      <div className="relatorio-table">
        <Table responsive hover>
          <thead>
            <tr>
              {tabela.canto_superior.map((label, index) => (
                <th
                  key={label}
                  className={index === 0
                    ? 'matriz-precos-table__label-col'
                    : 'matriz-precos-table__label-col matriz-precos-table__canto-secundario'}
                >
                  {label}
                </th>
              ))}
              {tabela.colunas_percentual.map((coluna) => (
                <th key={coluna} rowSpan={2}>{coluna}</th>
              ))}
            </tr>
            <tr>
              <th
                colSpan={tabela.canto_superior.length}
                className="matriz-precos-table__label-col matriz-precos-table__canto-secundario"
              >
                {tabela.canto_inferior}
              </th>
            </tr>
          </thead>
          <tbody>
            {tabela.linhas.map((linha, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <tr key={index}>
                <td colSpan={tabela.canto_superior.length} className="matriz-precos-table__label-col">
                  {linha.rotulo}
                </td>
                {linha.valores.map((valor, valorIndex) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <td key={valorIndex}>{formatNumberBR(valor)}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </>
  );
}
